var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeathers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "feathers",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.36,107.73c4.04-6.33,7.9-12.81,12.18-19,5.33-7.69,15.64-11.15,23.79-8.14,8.23,3.05,11.34,11.21,8.06,19.34-3.25,8.05-9.64,13.11-16.7,17.44-1.4.86-3.42.93-5.16.96-14.97.27-29.94.81-44.9.52-8.64-.17-15.6-5.06-20.66-11.73-3.65-4.81-4.5-10.44-1.57-16.58,3.79-7.94,14.07-10.42,22.24-6.94,10.2,4.35,15.94,13.21,21.54,22.13.51.81.97,1.64,1.18,2h0Z",
    className: "feather-fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeathers);
export default __webpack_public_path__ + "static/media/feathers.48cbed4bf18f8a247d078de7ecc53086.svg";
export { ForwardRef as ReactComponent };